import { IntelligentPhotoCaptureAttachmentIterationStatus, IntelligentPhotoCaptureEstimatorCaptureMode } from '../enums';
import { ImageUploadProgressBarConstants, EMPTY_UPLOAD_STATUS } from '../constants';
export const buildUploadStatus = (message, progress) => ({
    showProgressStatus: true,
    message,
    progress,
    isProgressPercentageDisplayed: false
});
export const getUploadedFilesCount = (iterationInfo, batchAttachmentCountById) => {
    if (iterationInfo.iterationStatus === IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED) {
        return iterationInfo.iterationFiles.length;
    }
    if (iterationInfo.iterationStatus !== IntelligentPhotoCaptureAttachmentIterationStatus.IN_PROGRESS) {
        return 0;
    }
    const uploadedCount = iterationInfo.batchIds.reduce((count, batchId) => count + (batchAttachmentCountById.get(batchId) || 0), 0);
    return Math.min(uploadedCount, iterationInfo.iterationFiles.length);
};
export const calculateProgressSummary = (attachmentIterationInfo, batchAttachmentCountById) => {
    const activeUploadIterations = attachmentIterationInfo.filter(iteration => iteration.iterationStatus === IntelligentPhotoCaptureAttachmentIterationStatus.PENDING ||
        iteration.iterationStatus === IntelligentPhotoCaptureAttachmentIterationStatus.IN_PROGRESS);
    const { totalFilesCount, uploadedFilesCount } = activeUploadIterations.reduce((acc, iteration) => {
        acc.totalFilesCount += iteration.iterationFiles.length;
        acc.uploadedFilesCount += getUploadedFilesCount(iteration, batchAttachmentCountById);
        return acc;
    }, { totalFilesCount: 0, uploadedFilesCount: 0 });
    const overallProgress = totalFilesCount
        ? Math.min(ImageUploadProgressBarConstants.HUNDRED_PERCENT, Math.trunc((uploadedFilesCount / totalFilesCount) * ImageUploadProgressBarConstants.HUNDRED_PERCENT))
        : 0;
    return { totalFilesCount, uploadedFilesCount, overallProgress };
};
export const isIterationsPendingOrInProgress = (attachmentIterationInfo) => attachmentIterationInfo.some(iteration => iteration.iterationStatus === IntelligentPhotoCaptureAttachmentIterationStatus.PENDING ||
    iteration.iterationStatus === IntelligentPhotoCaptureAttachmentIterationStatus.IN_PROGRESS);
export const isAnalyzingIterations = (attachmentIterationInfo) => attachmentIterationInfo.some(iteration => iteration.captureMode !== IntelligentPhotoCaptureEstimatorCaptureMode.UPLOAD_FILES &&
    iteration.iterationStatus === IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED &&
    iteration.batchIds.length > 0 &&
    (iteration.damageProcessStatus === IntelligentPhotoCaptureAttachmentIterationStatus.PENDING ||
        iteration.damageProcessStatus === IntelligentPhotoCaptureAttachmentIterationStatus.IN_PROGRESS));
export const calculateUploadStatus = (progressSummary, hasEnteredAnalyzingState, hasPendingOrInProgressIteration, hasAnalyzingIteration, organizingAnalyzingMessage, uploadingProgressText) => {
    if (!progressSummary.totalFilesCount)
        return EMPTY_UPLOAD_STATUS;
    if (hasEnteredAnalyzingState || hasAnalyzingIteration) {
        return buildUploadStatus(organizingAnalyzingMessage, ImageUploadProgressBarConstants.HUNDRED_PERCENT);
    }
    if (hasPendingOrInProgressIteration) {
        const progress = Math.max(ImageUploadProgressBarConstants.MIN_UPLOAD_PROGRESS, Math.min(progressSummary.overallProgress, ImageUploadProgressBarConstants.HUNDRED_PERCENT - 1));
        return buildUploadStatus(uploadingProgressText, progress);
    }
    return EMPTY_UPLOAD_STATUS;
};
/**
 * Updates the damageCallStatus and damageProcessStatus to COMPLETED and sets damageCallAt timestamp for the iteration matching the provided iterationId. If iterationId is invalid or not found, returns the original attachmentIterationInfo array unchanged.
 * @param attachmentIterationInfo - Array of iteration info objects to be updated
 * @param iterationId - The iterationId for which the damage statuses should be updated
 * @returns Updated array of iteration info objects with modified damage statuses for the matching iteration
 */
export const updateDamageStatusesByIterationId = (attachmentIterationInfo, iterationId) => {
    if (typeof iterationId !== 'number' || !Number.isFinite(iterationId)) {
        return attachmentIterationInfo;
    }
    const targetIndex = attachmentIterationInfo.findIndex(iteration => iteration.iterationId === iterationId);
    if (targetIndex === -1) {
        return attachmentIterationInfo;
    }
    return attachmentIterationInfo.map((iteration, index) => index === targetIndex
        ? Object.assign(Object.assign({}, iteration), { damageCallAt: Date.now(), damageCallStatus: IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED, damageProcessStatus: IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED }) : iteration);
};
//# sourceMappingURL=imageUploadProgressBarUtilities.js.map